/* eslint-disable jsx-a11y/media-has-caption */



import React, { useState, useCallback, useRef, useEffect } from 'react';
import cx from 'classnames';

import PlayButton from './PlayButton';

import './styles/_video-player.scss';








const VideoPlayer = ({
  videoUrl,
  thumbnailUrl,
  brandingColor = '#000',
  showControls = true
}) => {
  const videoWrapperRef = useRef(null);
  const videoPlayerRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [controlsVisible, setControlsVisible] = useState(false);
  const [hasPlayed, setHasPlayed] = useState(false);

  const showThumbnail = thumbnailUrl &&
  !playing && (
  !videoPlayerRef.current || videoPlayerRef.current.currentTime === 0);

  const onClickTogglePlay = useCallback(() => {
    if (!videoPlayerRef.current) {return void 0;}

    if (playing) {
      videoPlayerRef.current.pause();
      setPlaying(false);
    } else {
      videoPlayerRef.current.play();
      setPlaying(true);
    }
  }, [playing]);

  const getPlayToggle = (newValue) => () => setPlaying(newValue);

  const onKeyDown = (
  event) =>
  {
    // Toggle playing on SPACEBAR
    if (event.key === ' ') {
      event.preventDefault();
      onClickTogglePlay();
    }
  };

  useEffect(() => {
    if (playing && !hasPlayed) {
      setHasPlayed(true);
    }
  }, [playing, hasPlayed, setHasPlayed]);

  useEffect(() => {
    if (hasPlayed && videoWrapperRef.current) {
      if (videoWrapperRef.current instanceof HTMLDivElement) {
        videoWrapperRef.current.addEventListener('mouseover', () => setControlsVisible(true));
      }
      if (videoWrapperRef.current instanceof HTMLDivElement) {
        videoWrapperRef.current.addEventListener('mouseout', () => setControlsVisible(false));
      }
    }
  }, [hasPlayed]);

  return (
    <div ref={videoWrapperRef} className="video-player">
      {!playing && videoUrl &&
      <PlayButton
        className="video-player__play"
        onClick={onClickTogglePlay}
        onKeyDown={onKeyDown}
        color={brandingColor}
        tabIndex={-1} />}


      {showThumbnail &&
      <div className="video-player__thumbnail">
          <img
          src={thumbnailUrl}
          role="presentation"
          alt=""
          className="video-player__thumbnail__img" />

        </div>}

      {videoUrl &&
      <video
        key={videoUrl}
        onPause={getPlayToggle(false)}
        onPlay={getPlayToggle(true)}
        className={
        cx(
          'video-player__video',
          {
            'video-player__video--hidden': showThumbnail
          }
        )}

        ref={videoPlayerRef}
        controls={showControls && controlsVisible}>

          <source src={videoUrl} />
        </video>}

    </div>);

};

export default VideoPlayer;